import React, { useState } from "react";
import "./FAQ.css";
import { Accordion } from "react-bootstrap";

const FAQ = () => {
  const [activeCategory, setActiveCategory] = useState("Program");
  const categories = [
    "Program",
    "Teaching",
    "Mentors",
    "Placement Support",
    "Tuition fee",
  ];

  const faqData = {
    Program: [
      {
        question: "What is PST academy?",
        answer:
          "PST Academy is a professional training platform providing structured live learning programs.",
      },
      {
        question: "Who is eligible for PST academy?",
        answer:
          "Anyone passionate about learning and career growth can enroll in PST Academy.",
      },
      {
        question: "When are the live classes held?",
        answer:
          "Live classes are conducted on scheduled weekdays and weekends.",
      },
      {
        question: "Does PST give certificates?",
        answer: "Yes, certificates are provided after successful completion.",
      },
      {
        question: "Is PST Academy's certification worth it?",
        answer:
          "The certification is industry-aligned and helps enhance career opportunities.",
      },
    ],

    Teaching: [
      {
        question: "How are the classes conducted?",
        answer:
          "Classes are conducted live via interactive online sessions with practical demonstrations.",
      },
      {
        question: "Are the sessions interactive?",
        answer:
          "Yes, students can ask questions and interact directly with mentors during sessions.",
      },
    ],

    Mentors: [
      {
        question: "Who are the mentors?",
        answer:
          "Our mentors are industry professionals with real-world experience.",
      },
      {
        question: "Can I connect with mentors personally?",
        answer:
          "Yes, mentorship support is provided through doubt-clearing sessions.",
      },
    ],

    "Placement Support": [
      {
        question: "Do you provide placement support?",
        answer:
          "Yes, we offer resume building, mock interviews, and job referrals.",
      },
      {
        question: "Is placement guaranteed?",
        answer:
          "While placement is not guaranteed, we provide strong career assistance.",
      },
    ],

    "Tuition fee": [
      {
        question: "What is the course fee?",
        answer: "The fee varies depending on the program you choose.",
      },
      {
        question: "Are EMI options available?",
        answer: "Yes, we provide flexible EMI options for students.",
      },
    ],
  };

  return (
    <section className="FAQ">
      <div className="container">
        <div className="FAQ_header">
          <h5>
            Frequently Asked <span className="title_span">Questions</span>{" "}
          </h5>
          <span>
            <img
              src="/assets/images/home/FAQ/title-img.png"
              alt="title-img"
              className="title_img"
            />
          </span>
        </div>

        <div className="FAQ_div">
          <div className="row justify-content-center">
            <div className="col-lg-3 col-md-3 col-sm-4">
              <div className="faq_categories">
                {categories.map((item, index) => (
                  <div
                    key={index}
                    className={`faq_category_item ${
                      activeCategory === item ? "active" : ""
                    }`}
                    onClick={() => setActiveCategory(item)}
                  >
                    {item}
                  </div>
                ))}
              </div>
            </div>

            <div className="col-lg-8 col-md-9 col-sm-8">
              <div className="faq_content ">
                <div className="faq_content_header">{activeCategory}</div>

                <Accordion alwaysOpen>
                  {faqData[activeCategory].map((faq, index) => (
                    <Accordion.Item eventKey={index.toString()} key={index}>
                      <Accordion.Header>{faq.question}</Accordion.Header>
                      <Accordion.Body>{faq.answer}</Accordion.Body>
                    </Accordion.Item>
                  ))}
                </Accordion>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
